import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Wallet($$anchor, $$props) {
	const iconNode = [
		[
			"path",

			{
				"d": "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
			}
		],

		["path", { "d": "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiV2FsbGV0LnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xOSA3VjRhMSAxIDAgMCAwLTEtMUg1YTIgMiAwIDAgMCAwIDRoMTVhMSAxIDAgMCAxIDEgMXY0aC0zYTIgMiAwIDAgMCAwIDRoM2ExIDEgMCAwIDAgMS0xdi0yYTEgMSAwIDAgMC0xLTFcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0zIDV2MTRhMiAyIDAgMCAwIDIgMmgxNWExIDEgMCAwIDAgMS0xdi00XCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOztrREFEbEMsQ0FBQztPQUVPLFFBQTRDOztHQUFLLE1BQU07OztJQUFJLEdBQUcsRUFBRSw0R0FBNEc7Ozs7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLDJDQUEyQzs7O0tBQzlPLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9